export default __webpack_public_path__ + "static/media/Monarca.1664cf8a.jpg";